import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getUsersAll } from 'modules/settings/api';

export const useQueryUsersAll = () => {
  const { data, isLoading, isError } = useQuery(QUERY_KEYS.SETTINGS_PROFILE_USERS_ALL, getUsersAll);

  return {
    usersAllData: data,
    usersAllLoading: isLoading,
    usersAllError: isError,
  };
};
